// removed by extract-text-webpack-plugin
module.exports = {"player-name":"if1A4QURNUWlSHzlVZ_es_0","preview-deck":"_3Ed_v7wTrSU_l5NhA9L9b-_0","card":"_1g4e-qW_QtMc03Hi42wPmi_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55a730ec","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/game-states/EXECUTIVE_ACTION/actions/preview-deck.vue
// module id = 211
// module chunks = 0